import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { catchError, from, map, Observable, of, switchMap, take, tap, throwError } from 'rxjs';
import { environment } from 'src/app/environments/environment';
import { ApiResponse, PaginatedResponse } from 'src/app/core/interfaces/api-response.interface';
import { SidebarCategory } from 'src/app/core/interfaces/auth-state.interface';
import { User } from '../interfaces/user.interface';
import { TerminosCondiciones } from '../interfaces/terms-and-conditions.interface';
import { LoginFirebaseService } from './login-firebase.service';
import { BYPASS_AUTH } from 'src/app/core/tokens/auth.tokens';

@Injectable({providedIn: 'root'})
export class LoginCamposolService {

    private baseUrl = environment.apiUrl;
    public termsAndConditions: string[] = [];
    private httpClient = inject(HttpClient);
    private loginFirebaseService = inject(LoginFirebaseService);

    sendFirebaseTokenToCamposol(): Observable<ApiResponse<User>>{
        return from(Promise.resolve(this.loginFirebaseService.firebaseIdToken())).pipe(
            switchMap(token => {
                if (!token) {
                    return throwError(() => new Error('Token no disponible'));
                }
                
                const headers = new HttpHeaders()
                    .set('Authorization', `Bearer ${token}`)
                    .set('token_type', 'firebase');
                
                return this.httpClient.get<ApiResponse<User>>(
                    `${this.baseUrl}/api/v1/login/auth`,
                    { 
                        headers,
                        context: new HttpContext().set(BYPASS_AUTH, true)
                    }
                );
            }),
            catchError( error => {
                return throwError( () => error.error?.message || error.error?.error || error.message || 'Error interno.');
            })
        );
    }

    getTermsAndConditions(): Observable<ApiResponse<TerminosCondiciones>> {
        return this.httpClient.get<ApiResponse<TerminosCondiciones>>(`${this.baseUrl}/api/v1/login/terminoscondiciones`).pipe(
            tap( ({ data }) => {
                this.termsAndConditions = data.descripcion.split('\n')
            })
        )
    }
    
    onAcceptTerms(): Observable<boolean>{
        return this.httpClient.post<boolean>(`${this.baseUrl}/api/v1/login/aceptarterminos`, {}).pipe(
            map( () => true),
            catchError( () => of(false))
        )
    }

    onFirstValidLogin(): Observable<boolean> {
        return this.httpClient.put<boolean>(`${this.baseUrl}/api/v1/login/first-login`, {}).pipe(
            map( () => true),
            catchError( () => of(false))
        )
    }

    getSidebarMenu(): Observable<PaginatedResponse<SidebarCategory>> {
        return this.httpClient.post<PaginatedResponse<SidebarCategory>>(
            `${this.baseUrl}/api/v1/login/data/query`,
            { codigo_reporte: 'listado-categorias-modulos' },
            { 
                context: new HttpContext().set(BYPASS_AUTH, true)
            }
        ).pipe(
            take(1),
            catchError(error => {
                console.error('[getSidebarMenu] Error al obtener el menú:', error);
                return throwError(() => error);
            })
        );
    }
}
